import { createContext, useContext, useState, useSyncExternalStore } from 'react';
import type { ReactNode } from 'react';
import { ApiClient, apiBaseUrl } from './client';
import { SessionStore, type Session } from './session';

const ApiContext = createContext<ApiClient | null>(null);

/** The panel's one ApiClient (tests pass their own, with a fake fetch and an in-memory session). */
export function ApiProvider({ client, children }: { client?: ApiClient; children: ReactNode }) {
  const [value] = useState(() => client ?? new ApiClient(apiBaseUrl(), new SessionStore()));
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) throw new Error('useApi outside <ApiProvider>');
  return client;
}

/** The current session; re-renders on sign-in, refresh and sign-out. */
export function useSession(): Session | null {
  const { session } = useApi();
  return useSyncExternalStore(
    (onChange) => session.subscribe(onChange),
    () => session.get(),
    () => session.get(),
  );
}
